import { createContext } from 'react';

export interface IScenarioContext {
  activeScenarioId: string | null;
  activeScenarioName: string | null;
  isSwitching: boolean;
  isResolvingScenario: boolean;
  switchTarget: string | null;
  setActiveScenario: (scenarioId: string | null, scenarioName: string | null) => void;
}

const ScenarioContext = createContext<IScenarioContext | null>(null);

export default ScenarioContext;
